(function () {
  const tabs       = document.querySelectorAll('.contact-tabbed__tab');
  const tagField   = document.getElementById('contact-tag');
  const ctxField   = document.getElementById('contact-context');
  const ctxWrap    = document.getElementById('tab-context-field');

  // Context field config per tab
  const tabConfig = {
    general:      { tag: 'general-enquiry',      context: null },
    reservations: { tag: 'reservation-enquiry',  context: 'Preferred date & time' },
    wholesale:    { tag: 'wholesale-enquiry',     context: 'Business name & location' },
    media:        { tag: 'media-enquiry',         context: 'Publication or outlet' }
  };

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');

      const cfg = tabConfig[tab.dataset.tab];
      if (!cfg) return;

      // Swap routing tag
      if (tagField) tagField.value = cfg.tag;

      // Show/hide context field
      if (ctxWrap && ctxField) {
        if (cfg.context) {
          ctxField.placeholder = cfg.context;
          ctxField.name = 'contact[' + cfg.context + ']';
          ctxWrap.classList.remove('hidden');
        } else {
          ctxWrap.classList.add('hidden');
          ctxField.value = '';
        }
      }
    });
  });
})();
